<template>
<div id="bottom2">
    <div class="bg-color-black">
        <div class="cc-header">
            <dv-decoration-2 :color="['#4ccbda', '#4ccbda']" style="width:4rem;height:0.1rem;margin-left:0.2rem;transform: rotateY(180deg);" />
            <div>通行次数时间段分布</div>
            <dv-decoration-2 :color="['#4ccbda', '#4ccbda']" style="width:4rem;height:0.1rem;margin-right:0.2rem;" />
        </div>
        <div class="d-flex jc-center">
            <div id="lineChart" class="lineChart"></div>
        </div>
    </div>
</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
export default {
    data() {
        return {};
    },
    mounted() {
        this.initData();
        // 定时器刷新，30分钟
        let _this = this;
        setInterval(() => {
            _this.initData(); // 修改数据date
        }, 1000 * 60 * 30);
    },
    methods: {
        initData() {
            // 基于准备好的dom，初始化echarts实例
            let myChartPieLeft = echarts.init(
                document.getElementById("lineChart")
            );
            this.$http.get("/dataView/gate/getCountGroupByTime?orgCode=" + orgCode).then(res => {
                if (res.data.code === 200) {
                    var legends = res.data.result.legends;
                    var xAxisData = res.data.result.xData;
                    var yData = res.data.result.yData;
                    var yAxisData = [];
                    var colors = ["#8BC34A", "#F44336", "#FFEB3B", "#00BCD4", "#03A9F4", "#FF9800", "#c6d629", "#795548", "#e0306c", "#a70fc1"];
                    for (var i = 0; i < yData.length; i++) {
                        if (i > 9) {
                            yAxisData.push({
                                name: yData[i].name,
                                type: 'line',
                                smooth: true,
                                data: yData[i].data
                            });
                        } else {
                            yAxisData.push({
                                name: yData[i].name,
                                type: 'line',
                                smooth: true,
                                data: yData[i].data,
                                itemStyle: {
                                    normal: {
                                        color: colors[i], //折线点的颜色
                                        lineStyle: {
                                            color: colors[i] //折线的颜色
                                        }
                                    }
                                }
                            });
                        }
                    }

                    var option = {
                        tooltip: {
                            trigger: 'axis'
                        },
                        legend: {
                            show: false,
                            orient: 'vertical',
                            x: 'left', //可设定图例在左、右、居中
                            y: 'top', //可设定图例在上、下、居中
                            padding: [0, 0, 0, 0], //可设定图例[距上方距离，距右方距离，距下方距离，距左方距离]
                            data: legends,
							itemGap: 30,
                            textStyle: {
                                color: '#fff'
                            },
                            formatter: function (params) {
                                if (!params) return '';
                                if (params.length > 5) {
                                    return params.slice(0, 5) + '...';
                                } else {
                                    return params;
                                }
                            },
                            tooltip: {
                                show: true
                            }
                        },
                        grid: {
                            left: '5%',
                            right: '5%',
                            bottom: '5%',
							height: "79%",// 高度，
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: xAxisData,
                            axisLine: {
                                lineStyle: {
                                    color: '#fff'
                                }
                            },
                            axisLabel: {
                                interval: 1,
                                rotate: 60
                            }
                        },
                        yAxis: {
                            type: 'value',
                            axisLine: {
                                lineStyle: {
                                    color: '#fff'
                                }
                            }
                        },
                        series: yAxisData
                    }
                }
                myChartPieLeft.hideLoading(); //没有加载出来隐藏加载动画
                myChartPieLeft.setOption(option);
                // 响应式变化
                window.addEventListener("resize", () => myChartPieLeft.resize(), false);
            });
        }
    },
    destroyed() {
        window.onresize = null;
    }
};
</script>

<style lang="scss">
#bottom2 {
    height: 35vh;
    .cc-header {
        
        color: #fff;
        display: flex;
		height: 0.4rem;
		font-size: 0.3rem;
        justify-content: space-between;
        align-items: center;
    }

    .lineChart {
        width: 95%;
        height: 40vh;
		margin-top: -0.3rem;
    }
}
</style>
